import BackendUnavailable from "../../components/BackendUnavailable";
export default function SmtpSettingHTML(){return <BackendUnavailable title="SMTP settings" detail="Email delivery is currently configured on the server. The supplied backend does not expose an SMTP settings controller."/>;}
